<!-- 头部组件 -->
<script lang='ts' setup>
import { listData } from '../listData/data'
import DownShow from '../components/DownShow.vue'
import { downData, downShowType } from '../listData/downShow'
import { ref, onMounted, watch } from 'vue'
let downFalse = ref<boolean>(false)
let listDataType = ref<downShowType>({})
const pullDown = (num: number) => {
    listDataType.value = downData[num]
    num != 0 ? downFalse.value = true : downFalse.value = false
}
let leaveDown = (str: boolean) => str ? downFalse.value = false : downFalse.value = true
//监听滑轮事件
let show = ref<boolean>(true)
//滑轮的值
// let scrollTop = ref<number>(0)
// watch(scrollTop, (newVal, oldVal) => {
//     if (oldVal == undefined || newVal == undefined) {
//         oldVal = 0
//         newVal = 0
//     } else {
//         if (newVal > 300) {
//             show.value = false
//             if (oldVal > newVal) {
//                 show.value = true
//             }
//             else {
//                 show.value = false
//             }
//         }
//     }
//     if (newVal == 0) {
//         show.value = true
//     }
// })
// onMounted(() => {
//     window.addEventListener('scroll', function () {
//         scrollTop.value = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
//     });
// })
const onClickLi = (val: boolean) => {
    downFalse.value = val
}
const downFalseFn = (val: boolean) => {
    downFalse.value = val
}
</script>
<template>
    <header>
        <transition name="el-zoom-in-top">
            <div v-show="show" class="transition-box">
                <div class="welcome" @mouseover="leaveDown(true)">欢迎访问，江苏南通（宇启升）机电设备有限公司官网 ！
                    全国服务：<span style="font-size: 25px;">400-016-2918/13809089616</span>
                </div>
                <div class="container">
                    <div class="log"></div>
                    <!-- 功能列表 -->
                    <div>
                        <ul class="listFn">
                            <router-link v-for="(item, index) in listData" :key="item.name" :to="item.path">
                                <li @mouseover="pullDown(index)" @click="leaveDown(true)"> {{ item.name }} </li>
                            </router-link>
                            <div @mouseover="leaveDown(true)" class="markLaye"></div>
                        </ul>
                    </div>
                </div>
                <div class="down" v-if="downFalse" @mouseleave="leaveDown(true)">
                    <DownShow :listData='listDataType' @onClick-li="onClickLi" @downFalse="downFalseFn" />
                </div>
            </div>
        </transition>
    </header>
</template>
<style  lang='less' scoped>
.flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

header {
    .transition-box {
        position: fixed;
        top: 0;
        left: 0;
        min-height: 50px;
        z-index: 10;
        width: 100%;
        background-color: rgba(#147fad);
    }

    .down {
        position: absolute;
        top: 134px;
        left: 0;
        width: 100%;
        background: rgba(#147fad, .9);
        z-index: 99;
    }

    .welcome {
        padding: 10px;
        color: #fff;
        font-size: 18px;
    }

    .container {
        width: 100%;
        min-height: 90px;
        margin: 0 auto;
        .flex();

        .log {
            background: url('../assets/image/logo.png') no-repeat;
            background-size: contain;
            width: 300px;
            height: 50px;
        }

        .listFn {
            .flex();

            .markLaye {
                position: absolute;
                top: 0;
                right: 0;
                width: 180px;
                height: 90px;
            }

            li {
                height: 90px;
                line-height: 90px;
                width: 100px;
                text-align: center;
                font-size: 16px;
            }

            li:hover {
                background-color: rgba(#f00, .4);
            }
        }
    }
}


@media screen and (max-width: 768px) {
    header {
        .welcome {
            display: none;
        }

        .container {
            min-height: 0;
            display: block;

            .listFn {
                margin: 0 10px;
                li {
                    height: 12px;
                    line-height: 12px;
                    width: auto;
                    font-size: 12px;
                    margin: 10px 0;
                }
                .markLaye {
                    display: none;
                }
            }
        }
        .down {
            display: none;
        }
    }
}
</style>